import React from "react";
import Layout from "../../../shared/Layout/Layout";
import NewsHeader from "../../../shared/Components/NewsHeader";
import FirstFundRaisingDetails from "./component/FirstFundRaisingDetails";

export default function FirstFundRaising() {
  return (
    <Layout>
      <NewsHeader>
        First Impact Fund Raising Initiative In Bangladesh
      </NewsHeader>
      <FirstFundRaisingDetails />
    </Layout>
  );
}
